import { render, staticRenderFns } from "./CouponsList.vue?vue&type=template&id=49ef740e&scoped=true&"
import script from "./CouponsList.vue?vue&type=script&lang=js&"
export * from "./CouponsList.vue?vue&type=script&lang=js&"
import style0 from "./CouponsList.vue?vue&type=style&index=0&id=49ef740e&lang=scss&scoped=true&"
import style1 from "./CouponsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef740e",
  null
  
)

export default component.exports